import React, { Component } from 'react';


class Checkbox extends Component {


    state={
        id:"",
        text: "",
        width:"",
        offset:"",
        size:"",
        defaultValue: 0,
        hidden:"",
        required: false,
        showLabel: true,
        rowIndex: -1,
        checked: false
    }

    //initial state
    constructor(props){
        super(props)

        this.state.id= props.data.domain;
        if(this.state.id === ''){
            this.state.id= props.data.text;
        }
        this.state.text = props.data.text;
        this.state.width = props.data.width;
        this.state.size = props.data.size;
        this.state.offset = props.data.offset;
        this.state.defaultValue = props.data.defaultValue;
        this.state.hidden = props.data.hidden;
        this.state.required = props.required;     
        this.state.showLabel = props.showLabel;       
        this.state.rowIndex = props.rowIndex;
        if(this.state.defaultValue == 1){
            this.state.checked = true
        }else{
            this.state.checked = false
        }
        props.addToResult(this.state.id, this.state.defaultValue, this.state.rowIndex);
    }

    counter = 0;
    getCounter = ()=>{
        return this.counter++
    }

    handleChange = (selectName, e) => {
        if(e.target.checked){
            e.target.value = 1
        }else{
            e.target.value = 0
        }
        this.setState({defaultValue:e.target.value});
        this.props.addToResult(selectName, e.target.value, this.state.rowIndex);
    };

    getWidthClass(width) {
        switch (width) {
            case 0:
                return "";
            case 1:
                return "col-1";
            case 2:
                return "col-2";
            case 3:
                return "col-3";
            case 4:
                return "col-4";
            case 5:
                return "col-5";
            case 6:
                return "col-6";
            case 7:
                return "col-7";
            case 8:
                return "col-8";
            case 9:
                return "col-9";
            case 10:
                return "col-10";
            case 11:
                return "col-11";
            case 12:
                return "col-12";
            default:
                //return <Input addToResult={this.addToResult} formJson={item} />
                return "";
        }                
    }

    getOffsetClass(offset) {
        switch (offset) {
            case 0:
                return "";
            case 1:
                return "offset-1";
            case 2:
                return "offset-2";
            case 3:
                return "offset-3";
            case 4:
                return "offset-4";
            case 5:
                return "offset-5";
            case 6:
                return "offset-6";
            case 7:
                return "offset-7";
            case 8:
                return "offset-8";
            case 9:
                return "offset-9";
            case 10:
                return "offset-10";
            case 11:
                return "offset-11";
            default:
                //return <Input addToResult={this.addToResult} formJson={item} />
                return "";
        }                
    }

    getClassElement(width, offset) {
        return this.getWidthClass(width) +" " + this.getOffsetClass(offset);
    }

    render() {
            let label;
            
            if (this.state.showLabel){
                label = <label htmlFor={this.state.id}>{this.state.text}</label>
            }      
             
            if(this.state.showLabel){
                return(<div class="col-12" hidden={this.state.hidden ||''}>
                        {label}
                        <input type="checkbox" className= "" id= {this.state.id}
                        defaultChecked={this.state.checked}
                        required={this.state.required}
                        onChange={e => this.handleChange(this.state.id, e)}                    
                        name={this.state.id}
                        maxLength={this.state.size}
                        value={this.state.defaultValue}
                        autocomplete="off" 
                        autocorrect="off" 
                        autocapitalize="off" 
                        spellcheck="false" 
                        oncopy="return false" 
                        onpaste="return false"/>                   
                    </div>);
            }else{
                return (
                    <div class="div-input-check" hidden={this.state.hidden ||''}>
                        <input type="checkbox" className= "" id= {this.state.id}
                        defaultChecked={this.state.checked}
                        required={this.state.required}
                        onChange={e => this.handleChange(this.state.id, e)}                    
                        name={this.state.id}
                        maxLength={this.state.size}
                        value={this.state.defaultValue}
                        autocomplete="off" 
                        autocorrect="off" 
                        autocapitalize="off" 
                        spellcheck="false" 
                        oncopy="return false" 
                        onpaste="return false"/>                   
                    </div>
                );
            }
            
    }
}

export default Checkbox;